import React from "react";
import "./css/post-7412.css";
import "./css/post-49.css";
import "./css/post-1297.css";
const About = () => {
  return (
    <div
      data-elementor-type="wp-page"
      data-elementor-id={7412}
      className="elementor elementor-7412"
    >
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-08c904b elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="08c904b"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-no">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2aad58a"
            data-id="2aad58a"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-819cd1a elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="819cd1a"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-wide">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-038b856"
                    data-id="038b856"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-5209b61 cmsmasters-separator-type-icon cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-breadcrumbs cmsmasters-widget-breadcrumbs"
                        data-id="5209b61"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-breadcrumbs.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="cmsmasters-widget-breadcrumbs__container">
                            <div className="cmsmasters-widget-breadcrumbs__content">
                              <a href="/" className="cmsmasters-home">
                                Home
                              </a>
                              <span className="cmsmasters-widget-breadcrumbs__sep">
                                <i className="cmsmsdemo-icon- cmsms-demo-icon-chevron-right" />
                              </span>
                              <span>About</span>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-874f58b elementor-section-full_width elementor-section-height-min-height elementor-section-height-default cmsmasters-bg-hide-none cmsmasters-bg-hide-none cmsmasters-block-default"
                data-id="874f58b"
                data-element_type="section"
                data-settings='{"background_background":"classic"}'
              >
                <div className="elementor-background-overlay" />
                <div className="elementor-container elementor-column-gap-wide">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-f9f06f2"
                    data-id="f9f06f2"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-04d0aa2 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="04d0aa2"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h1 className="elementor-heading-title elementor-size-default">
                            About Us
                          </h1>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-4758fc7 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="4758fc7"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c888257"
            data-id="c888257"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-b699d00 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                data-id="b699d00"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    Featured Post
                  </h2>{" "}
                </div>
              </div>
              <div
                className="elementor-element elementor-element-a3756f1 cmsmasters-About--layout-custom cmsmasters-About-grid-marker__marker-icon cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-About-grid elementor-widget-cmsmasters-About-similar"
                data-id="a3756f1"
                data-element_type="widget"
                data-settings='{"About_layout":"custom","About_template_id":"49","columns":"1","columns_mobile":"1","About_post_type":"post","query_control_prefix":"About","post_gap_row":{"unit":"px","size":"","sizes":[]},"post_gap_row_tablet":{"unit":"px","size":"","sizes":[]},"post_gap_row_mobile":{"unit":"px","size":"","sizes":[]},"border_columns_type":"solid","border_vertical_width":{"unit":"px","size":1,"sizes":[]},"border_vertical_width_tablet":{"unit":"px","size":"","sizes":[]},"border_vertical_width_mobile":{"unit":"px","size":"","sizes":[]},"border_horizontal_width":{"unit":"px","size":"","sizes":[]},"border_horizontal_width_tablet":{"unit":"px","size":"","sizes":[]},"border_horizontal_width_mobile":{"unit":"px","size":"","sizes":[]}}'
                data-widget_type="cmsmasters-About-grid.default"
                data-document-id={7412}
              >
                <div className="elementor-widget-container">
                  <div className="cmsmasters-About cmsmasters-About-grid cmsmasters-About--type-default">
                    <div className="cmsmasters-About__posts-variable">
                      <div className="cmsmasters-About__posts-wrap">
                        <div className="cmsmasters-About__posts">
                          <article
                            id="post-728"
                            className="cmsmasters-About__post post-728 post type-post status-publish format-standard has-post-thumbnail hentry category-new-digital tag-sustainability tag-sustainable-banking"
                          >
                            <div className="cmsmasters-About__post-inner">
                              <div
                                data-elementor-type="cmsmasters_entry"
                                data-elementor-id={49}
                                className="elementor elementor-49 cmsmasters-header-position-absolute-"
                              >
                                {" "}
                                <div className="elementor-inner">
                                  <div className="elementor-section-wrap">
                                    <section
                                      className="elementor-section elementor-top-section elementor-element elementor-element-744b325 elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                      data-id="744b325"
                                      data-element_type="section"
                                    >
                                      <div className="elementor-container elementor-column-gap-no">
                                        <div
                                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2c6f4eee"
                                          data-id="2c6f4eee"
                                          data-element_type="column"
                                        >
                                          <div className="elementor-widget-wrap elementor-element-populated">
                                            <div
                                              className="elementor-element elementor-element-78d88f36 cmsmasters-object-fit cmsmasters-object-fit-cover cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-featured-image cmsmasters-widget-image"
                                              data-id="78d88f36"
                                              data-element_type="widget"
                                              data-widget_type="cmsmasters-post-featured-image.default"
                                            >
                                              <div className="elementor-widget-container">
                                                <div className="cmsmasters-widget-image__wrap">
                                                  <a
                                                    href=""
                                                    data-elementor-open-lightbox
                                                    aria-label="Featured Image"
                                                  >
                                                    <img
                                                      fetchpriority="high"
                                                      decoding="async"
                                                      width={1024}
                                                      height={683}
                                                      src="/imges/about/about2.jpg"
                                                      className="attachment-large size-large wp-image-7032 cmsmasters_img cmsmasters-lazyload ls-is-cached lazyloaded"
                                                      alt=""
                                                      data-sizes="(max-width: 1024px) 100vw, 1024px"
                                                      //   data-src="/wp-content/uploads/sites/8/2021/04/About-9-1024x683.jpg"
                                                      //   data-srcset="/wp-content/uploads/sites/8/2021/04/About-9-1024x683.jpg 1024w, /wp-content/uploads/sites/8/2021/04/About-9-300x200.jpg 300w, /wp-content/uploads/sites/8/2021/04/About-9-768x512.jpg 768w, /wp-content/uploads/sites/8/2021/04/About-9-1536x1024.jpg 1536w, /wp-content/uploads/sites/8/2021/04/About-9-450x300.jpg 450w, /wp-content/uploads/sites/8/2021/04/About-9-600x400.jpg 600w, /wp-content/uploads/sites/8/2021/04/About-9-30x20.jpg 30w, /wp-content/uploads/sites/8/2021/04/About-9-15x10.jpg 15w, /wp-content/uploads/sites/8/2021/04/About-9.jpg 1920w"
                                                      //   srcSet="/wp-content/uploads/sites/8/2021/04/About-9-1024x683.jpg 1024w, /wp-content/uploads/sites/8/2021/04/About-9-300x200.jpg 300w, /wp-content/uploads/sites/8/2021/04/About-9-768x512.jpg 768w, /wp-content/uploads/sites/8/2021/04/About-9-1536x1024.jpg 1536w, /wp-content/uploads/sites/8/2021/04/About-9-450x300.jpg 450w, /wp-content/uploads/sites/8/2021/04/About-9-600x400.jpg 600w, /wp-content/uploads/sites/8/2021/04/About-9-30x20.jpg 30w, /wp-content/uploads/sites/8/2021/04/About-9-15x10.jpg 15w, /wp-content/uploads/sites/8/2021/04/About-9.jpg 1920w"
                                                      sizes="(max-width: 1024px) 100vw, 1024px"
                                                    />
                                                  </a>
                                                </div>{" "}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-514395bc"
                                          data-id="514395bc"
                                          data-element_type="column"
                                        >
                                          <div className="elementor-widget-wrap elementor-element-populated">
                                            {/* <div
                                              className="elementor-element elementor-element-1c8a5d2b cmsmasters-count--dir-row cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-meta-data"
                                              data-id="1c8a5d2b"
                                              data-element_type="widget"
                                              data-widget_type="cmsmasters-meta-data.default"
                                            >
                                              <div className="elementor-widget-container">
                                                <div className="cmsmasters-meta-data">
                                                  <div className="cmsmasters-meta-data__inner">
                                                    <div className="cmsmasters-meta-data__item elementor-repeater-item-d46c7b9">
                                                      <div className="cmsmasters-meta-data__item__inner">
                                                        <span
                                                          data-taxonomy="category"
                                                          className="cmsmasters-postmeta"
                                                          data-name="taxonomy"
                                                        >
                                                          <span className="cmsmasters-postmeta__inner">
                                                            <span className="cmsmasters-postmeta__content">
                                                              <span className="term-wrap">
                                                                <a
                                                                  className="term"
                                                                  rel="category tag"
                                                                  href="/category/new-digital/"
                                                                >
                                                                  <span>
                                                                    New Digital
                                                                  </span>
                                                                </a>
                                                              </span>
                                                            </span>
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <span className="item-sep" />
                                                    </div>
                                                    <div className="cmsmasters-meta-data__item elementor-repeater-item-a3f293c">
                                                      <div className="cmsmasters-meta-data__item__inner">
                                                        <span
                                                          data-type="reading_time"
                                                          className="cmsmasters-postmeta"
                                                          data-name="count"
                                                        >
                                                          <span className="cmsmasters-postmeta__inner">
                                                            <span className="cmsmasters-postmeta__content">
                                                              5
                                                            </span>
                                                          </span>
                                                        </span>
                                                        <span className="content-side content-after">
                                                          {" "}
                                                          min read
                                                        </span>
                                                      </div>
                                                      <span className="item-sep" />
                                                    </div>{" "}
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                            <div
                                              className="elementor-element elementor-element-27c76f41 cmsmasters-line-clamp-yes cmsmasters-color-variation-default cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-title cmsmasters-widget-title"
                                              data-id="27c76f41"
                                              data-element_type="widget"
                                              data-widget_type="cmsmasters-post-title.default"
                                            >
                                              <div className="elementor-widget-container">
                                                <h3
                                                  className="entry-title cmsmasters-widget-title__heading"
                                                  title="In Banking, Sustainability is the New Digital. Now What?"
                                                >
                                                  <a href="">About Burooj</a>
                                                </h3>{" "}
                                              </div>
                                            </div>
                                            <div
                                              className="elementor-element elementor-element-318a95a7 cmsmasters-line-clamp-yes cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-excerpt cmsmasters-widget-short-text"
                                              data-id="318a95a7"
                                              data-element_type="widget"
                                              data-widget_type="cmsmasters-post-excerpt.default"
                                            >
                                              <div
                                                className="elementor-widget-container"
                                                style={{
                                                  "-webkit-box-orient":
                                                    "revert",
                                                  overflow: "none",
                                                }}
                                              >
                                                <div className="entry-content">
                                                  <p>
                                                    Burooj is shaping the future
                                                    of investments with a bold
                                                    vision and a strategic
                                                    approach. As a dynamic
                                                    investment firm, we
                                                    specialize in identifying
                                                    high-growth opportunities
                                                    across diverse industries,
                                                    leveraging our expertise to
                                                    drive sustainable returns.
                                                    Our portfolio spans sectors
                                                    that define tomorrow—real
                                                    estate, technology, energy,
                                                    and consumer
                                                    markets—ensuring we stay
                                                    ahead in an ever-evolving
                                                    financial landscape.
                                                  </p>
                                                </div>{" "}
                                              </div>
                                            </div>
                                            {/* <section
                                              className="elementor-section elementor-inner-section elementor-element elementor-element-5cfb95cf elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                              data-id="5cfb95cf"
                                              data-element_type="section"
                                            >
                                              <div className="elementor-container elementor-column-gap-no">
                                                <div
                                                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-2f81ebe9"
                                                  data-id="2f81ebe9"
                                                  data-element_type="column"
                                                >
                                                  <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                      className="elementor-element elementor-element-465dffe4 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                                                      data-id="465dffe4"
                                                      data-element_type="widget"
                                                      data-widget_type="image.default"
                                                    >
                                                      <div className="elementor-widget-container">
                                                        <img
                                                          decoding="async"
                                                          src="https://secure.gravatar.com/avatar/cec22fb290043e2c1b9972d9bc2f0cfb?s=96&d=mm&r=g"
                                                          title
                                                          alt=""
                                                          loading="lazy"
                                                        />{" "}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-45552697"
                                                  data-id={45552697}
                                                  data-element_type="column"
                                                >
                                                  <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                      className="elementor-element elementor-element-4dbdc9a2 cmsmasters-count--dir-row cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-meta-data"
                                                      data-id="4dbdc9a2"
                                                      data-element_type="widget"
                                                      data-widget_type="cmsmasters-meta-data.default"
                                                    >
                                                      <div className="elementor-widget-container">
                                                        <div className="cmsmasters-meta-data">
                                                          <div className="cmsmasters-meta-data__inner">
                                                            <div className="cmsmasters-meta-data__item elementor-repeater-item-19ca8b4">
                                                              <div className="cmsmasters-meta-data__item__inner">
                                                                <span className="content-side content-before">
                                                                  by{" "}
                                                                </span>
                                                                <span
                                                                  className="cmsmasters-postmeta"
                                                                  data-name="author"
                                                                >
                                                                  <span className="cmsmasters-postmeta__inner">
                                                                    <span className="cmsmasters-postmeta__content">
                                                                      <a
                                                                        rel="author"
                                                                        href="/author/cmsmasters/"
                                                                      >
                                                                        <span>
                                                                          cmsmasters
                                                                        </span>
                                                                      </a>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </div>{" "}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="elementor-element elementor-element-96c2889 cmsmasters-count--dir-row cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-meta-data"
                                                      data-id="96c2889"
                                                      data-element_type="widget"
                                                      data-widget_type="cmsmasters-meta-data.default"
                                                    >
                                                      <div className="elementor-widget-container">
                                                        <div className="cmsmasters-meta-data">
                                                          <div className="cmsmasters-meta-data__inner">
                                                            <div className="cmsmasters-meta-data__item elementor-repeater-item-19ca8b4">
                                                              <div className="cmsmasters-meta-data__item__inner">
                                                                <span
                                                                  className="cmsmasters-postmeta"
                                                                  data-name="date"
                                                                >
                                                                  <span className="cmsmasters-postmeta__inner">
                                                                    <span className="cmsmasters-postmeta__content">
                                                                      <span>
                                                                        January
                                                                        22, 2024
                                                                      </span>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </div>{" "}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </section> */}
                                          </div>
                                        </div>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-2e2fb5c elementor-reverse-tablet elementor-reverse-mobile elementor-section-boxed elementor-section-height-default cmsmasters-block-default"
        data-id="2e2fb5c"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b643ec2"
            data-id="b643ec2"
            data-element_type="column"
            data-settings='{"background_background":"classic"}'
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-e052d24 elementor-section-full_width elementor-section-content-middle elementor-reverse-tablet elementor-reverse-mobile elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="e052d24"
                data-element_type="section"
                data-settings='{"background_background":"classic"}'
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-552b946"
                    data-id="552b946"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-a11e445 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="a11e445"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <div
                            className="elementor-heading-title elementor-size-default"
                            style={{ color: "#191B22" }}
                          >
                            What Sets Us Apart
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-4d65680 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="4d65680"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Defining the future, one investment at a time.
                          </h2>
                        </div>
                      </div>
                      {/* <div
                        className="elementor-element elementor-element-e056191 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="e056191"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <p className="elementor-heading-title elementor-size-default">
                            At Burooj, we transform real estate into
                            living, breathing spaces that cater to the needs of
                            today and aspirations of tomorrow.
                          </p>
                        </div>
                      </div> */}
                    </div>
                    {/* End widget-wrap for left column */}
                  </div>
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b588e3c"
                    data-id="b588e3c"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-8b3e7c8 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                        data-id="8b3e7c8"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <div className="elementor-widget-container">
                          <div
                            className="elementor-element elementor-element-f3ab9f4 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                            data-id="f3ab9f4"
                            data-element_type="widget"
                            data-widget_type="cmsmasters-icon-list.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="cmsmasters-widget-icon-list-items">
                                <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          Strategic Investments
                                        </span>
                                        <br />
                                        We focus on future-ready industries,
                                        aligning with global economic shifts and
                                        emerging trends.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                                <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          Risk-Managed Growth
                                        </span>
                                        <br /> Our approach balances innovation
                                        with stability, ensuring sustainable
                                        wealth creation.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                                <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          Global Reach, Local Expertise
                                        </span>
                                        <br /> With a presence in key financial
                                        hubs, we harness local market knowledge
                                        while maintaining a broad investment
                                        horizon.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                                <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          Ethical and Sustainable Investing
                                        </span>
                                        <br /> We prioritize responsible
                                        investment strategies that align with
                                        environmental, social, and governance
                                        (ESG) principles
                                      </span>
                                    </span>
                                  </span>
                                </li>
                                <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          Adaptive Market Positioning
                                        </span>
                                        <br /> We continuously monitor global
                                        and regional market dynamics, allowing
                                        us to pivot strategies proactively and
                                        seize new opportunities as they emerge.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-4758fc7 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="4758fc7"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c888257"
            data-id="c888257"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-b699d00 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                data-id="b699d00"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  {/* <h2 className="elementor-heading-title elementor-size-default">
                    Featured Post
                  </h2>{" "} */}
                </div>
              </div>
              <div
                className="elementor-element elementor-element-a3756f1 cmsmasters-About--layout-custom cmsmasters-About-grid-marker__marker-icon cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-About-grid elementor-widget-cmsmasters-About-similar"
                data-id="a3756f1"
                data-element_type="widget"
                data-settings='{"About_layout":"custom","About_template_id":"49","columns":"1","columns_mobile":"1","About_post_type":"post","query_control_prefix":"About","post_gap_row":{"unit":"px","size":"","sizes":[]},"post_gap_row_tablet":{"unit":"px","size":"","sizes":[]},"post_gap_row_mobile":{"unit":"px","size":"","sizes":[]},"border_columns_type":"solid","border_vertical_width":{"unit":"px","size":1,"sizes":[]},"border_vertical_width_tablet":{"unit":"px","size":"","sizes":[]},"border_vertical_width_mobile":{"unit":"px","size":"","sizes":[]},"border_horizontal_width":{"unit":"px","size":"","sizes":[]},"border_horizontal_width_tablet":{"unit":"px","size":"","sizes":[]},"border_horizontal_width_mobile":{"unit":"px","size":"","sizes":[]}}'
                data-widget_type="cmsmasters-About-grid.default"
                data-document-id={7412}
              >
                <div className="elementor-widget-container">
                  <div className="cmsmasters-About cmsmasters-About-grid cmsmasters-About--type-default">
                    <div className="cmsmasters-About__posts-variable">
                      <div className="cmsmasters-About__posts-wrap">
                        <div className="cmsmasters-About__posts">
                          <article
                            id="post-728"
                            className="cmsmasters-About__post post-728 post type-post status-publish format-standard has-post-thumbnail hentry category-new-digital tag-sustainability tag-sustainable-banking"
                          >
                            <div className="cmsmasters-About__post-inner">
                              <div
                                data-elementor-type="cmsmasters_entry"
                                data-elementor-id={49}
                                className="elementor elementor-49 cmsmasters-header-position-absolute-"
                              >
                                {" "}
                                <div className="elementor-inner">
                                  <div className="elementor-section-wrap">
                                    <section
                                      className="elementor-section elementor-top-section elementor-element elementor-element-744b325 elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                      data-id="744b325"
                                      data-element_type="section"
                                    >
                                      <div className="elementor-container elementor-column-gap-no">
                                        <div
                                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-514395bc"
                                          data-id="514395bc"
                                          data-element_type="column"
                                        >
                                          <div className="elementor-widget-wrap elementor-element-populated">
                                            <div
                                              className="elementor-element elementor-element-27c76f41 cmsmasters-line-clamp-yes cmsmasters-color-variation-default cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-title cmsmasters-widget-title"
                                              data-id="27c76f41"
                                              data-element_type="widget"
                                              data-widget_type="cmsmasters-post-title.default"
                                            >
                                              <div className="elementor-widget-container">
                                                <h3
                                                  className="entry-title cmsmasters-widget-title__heading"
                                                  title="In Banking, Sustainability is the New Digital. Now What?"
                                                >
                                                  <a href="">Our Philosophy</a>
                                                </h3>{" "}
                                              </div>
                                            </div>
                                            <div
                                              className="elementor-element elementor-element-318a95a7 cmsmasters-line-clamp-yes cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-excerpt cmsmasters-widget-short-text"
                                              data-id="318a95a7"
                                              data-element_type="widget"
                                              data-widget_type="cmsmasters-post-excerpt.default"
                                            >
                                              <div
                                                className="elementor-widget-container"
                                                style={{
                                                  "-webkit-box-orient":
                                                    "revert",
                                                  overflow: "none",
                                                }}
                                              >
                                                <div className="entry-content">
                                                  <p>
                                                    Investing with intelligence,
                                                    growing with purpose. We
                                                    believe in smart capital
                                                    allocation, guided by
                                                    in-depth market insights and
                                                    a commitment to long-term
                                                    value creation. Our
                                                    investment strategies
                                                    combine data-driven analysis
                                                    with a deep understanding of
                                                    global economic trends,
                                                    allowing us to make informed
                                                    decisions that maximize
                                                    impact. Our firm takes a
                                                    meticulous approach to
                                                    investment, identifying key
                                                    market gaps and aligning
                                                    capital with businesses that
                                                    hold the potential for
                                                    exponential growth. We
                                                    integrate innovation and
                                                    sustainability into our
                                                    investment philosophy,
                                                    ensuring long-term
                                                    prosperity for our partners
                                                    and stakeholders. By
                                                    leveraging our expertise in
                                                    analytics and financial
                                                    modeling, we craft
                                                    strategies that mitigate
                                                    risks while capitalizing on
                                                    lucrative opportunities in
                                                    global markets.
                                                  </p>
                                                </div>{" "}
                                              </div>
                                            </div>
                                            {/* <section
                                              className="elementor-section elementor-inner-section elementor-element elementor-element-5cfb95cf elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                              data-id="5cfb95cf"
                                              data-element_type="section"
                                            >
                                              <div className="elementor-container elementor-column-gap-no">
                                                <div
                                                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-2f81ebe9"
                                                  data-id="2f81ebe9"
                                                  data-element_type="column"
                                                >
                                                  <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                      className="elementor-element elementor-element-465dffe4 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                                                      data-id="465dffe4"
                                                      data-element_type="widget"
                                                      data-widget_type="image.default"
                                                    >
                                                      <div className="elementor-widget-container">
                                                        <img
                                                          decoding="async"
                                                          src="https://secure.gravatar.com/avatar/cec22fb290043e2c1b9972d9bc2f0cfb?s=96&d=mm&r=g"
                                                          title
                                                          alt=""
                                                          loading="lazy"
                                                        />{" "}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-45552697"
                                                  data-id={45552697}
                                                  data-element_type="column"
                                                >
                                                  <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                      className="elementor-element elementor-element-4dbdc9a2 cmsmasters-count--dir-row cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-meta-data"
                                                      data-id="4dbdc9a2"
                                                      data-element_type="widget"
                                                      data-widget_type="cmsmasters-meta-data.default"
                                                    >
                                                      <div className="elementor-widget-container">
                                                        <div className="cmsmasters-meta-data">
                                                          <div className="cmsmasters-meta-data__inner">
                                                            <div className="cmsmasters-meta-data__item elementor-repeater-item-19ca8b4">
                                                              <div className="cmsmasters-meta-data__item__inner">
                                                                <span className="content-side content-before">
                                                                  by{" "}
                                                                </span>
                                                                <span
                                                                  className="cmsmasters-postmeta"
                                                                  data-name="author"
                                                                >
                                                                  <span className="cmsmasters-postmeta__inner">
                                                                    <span className="cmsmasters-postmeta__content">
                                                                      <a
                                                                        rel="author"
                                                                        href="/author/cmsmasters/"
                                                                      >
                                                                        <span>
                                                                          cmsmasters
                                                                        </span>
                                                                      </a>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </div>{" "}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="elementor-element elementor-element-96c2889 cmsmasters-count--dir-row cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-meta-data"
                                                      data-id="96c2889"
                                                      data-element_type="widget"
                                                      data-widget_type="cmsmasters-meta-data.default"
                                                    >
                                                      <div className="elementor-widget-container">
                                                        <div className="cmsmasters-meta-data">
                                                          <div className="cmsmasters-meta-data__inner">
                                                            <div className="cmsmasters-meta-data__item elementor-repeater-item-19ca8b4">
                                                              <div className="cmsmasters-meta-data__item__inner">
                                                                <span
                                                                  className="cmsmasters-postmeta"
                                                                  data-name="date"
                                                                >
                                                                  <span className="cmsmasters-postmeta__inner">
                                                                    <span className="cmsmasters-postmeta__content">
                                                                      <span>
                                                                        January
                                                                        22, 2024
                                                                      </span>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </div>{" "}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </section> */}
                                          </div>
                                        </div>
                                        <div
                                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2c6f4eee"
                                          data-id="2c6f4eee"
                                          data-element_type="column"
                                        >
                                          <div className="elementor-widget-wrap elementor-element-populated">
                                            <div
                                              className="elementor-element elementor-element-78d88f36 cmsmasters-object-fit cmsmasters-object-fit-cover cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-featured-image cmsmasters-widget-image"
                                              data-id="78d88f36"
                                              data-element_type="widget"
                                              data-widget_type="cmsmasters-post-featured-image.default"
                                            >
                                              <div className="elementor-widget-container">
                                                <div className="cmsmasters-widget-image__wrap">
                                                  <a
                                                    href=""
                                                    data-elementor-open-lightbox
                                                    aria-label="Featured Image"
                                                  >
                                                    <img
                                                      fetchpriority="high"
                                                      decoding="async"
                                                      width={1024}
                                                      height={683}
                                                      src="/imges/about/about3.jpg"
                                                      className="attachment-large size-large wp-image-7032 cmsmasters_img cmsmasters-lazyload ls-is-cached lazyloaded"
                                                      alt=""
                                                      data-sizes="(max-width: 1024px) 100vw, 1024px"
                                                      //   data-src="/wp-content/uploads/sites/8/2021/04/About-9-1024x683.jpg"
                                                      //   data-srcset="/wp-content/uploads/sites/8/2021/04/About-9-1024x683.jpg 1024w, /wp-content/uploads/sites/8/2021/04/About-9-300x200.jpg 300w, /wp-content/uploads/sites/8/2021/04/About-9-768x512.jpg 768w, /wp-content/uploads/sites/8/2021/04/About-9-1536x1024.jpg 1536w, /wp-content/uploads/sites/8/2021/04/About-9-450x300.jpg 450w, /wp-content/uploads/sites/8/2021/04/About-9-600x400.jpg 600w, /wp-content/uploads/sites/8/2021/04/About-9-30x20.jpg 30w, /wp-content/uploads/sites/8/2021/04/About-9-15x10.jpg 15w, /wp-content/uploads/sites/8/2021/04/About-9.jpg 1920w"
                                                      //   srcSet="/wp-content/uploads/sites/8/2021/04/About-9-1024x683.jpg 1024w, /wp-content/uploads/sites/8/2021/04/About-9-300x200.jpg 300w, /wp-content/uploads/sites/8/2021/04/About-9-768x512.jpg 768w, /wp-content/uploads/sites/8/2021/04/About-9-1536x1024.jpg 1536w, /wp-content/uploads/sites/8/2021/04/About-9-450x300.jpg 450w, /wp-content/uploads/sites/8/2021/04/About-9-600x400.jpg 600w, /wp-content/uploads/sites/8/2021/04/About-9-30x20.jpg 30w, /wp-content/uploads/sites/8/2021/04/About-9-15x10.jpg 15w, /wp-content/uploads/sites/8/2021/04/About-9.jpg 1920w"
                                                      sizes="(max-width: 1024px) 100vw, 1024px"
                                                    />
                                                  </a>
                                                </div>{" "}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section
        className="elementor-section elementor-top-section elementor-element elementor-element-58e2a51 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="58e2a51"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9b442f1"
            data-id="9b442f1"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-bfcee6e elementor-section-full_width elementor-section-content-middle elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="bfcee6e"
                data-element_type="section"
                data-settings='{"background_background":"classic"}'
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-977debd"
                    data-id="977debd"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-63066e2 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                        data-id="63066e2"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <div className="elementor-widget-container">
                          <img
                            loading="lazy"
                            decoding="async"
                            width={770}
                            height={685}
                            src="/imges/about/newsletter-1.jpg"
                            className="attachment-large size-large wp-image-1470 cmsmasters_img cmsmasters-lazyload ls-is-cached lazyloaded"
                            alt=""
                            data-sizes="(max-width: 770px) 100vw, 770px"
                            // data-src="/wp-content/uploads/sites/8/2021/11/newsletter-1.jpg"
                            // data-srcset="/wp-content/uploads/sites/8/2021/11/newsletter-1.jpg 770w, /wp-content/uploads/sites/8/2021/11/newsletter-1-300x267.jpg 300w, /wp-content/uploads/sites/8/2021/11/newsletter-1-768x683.jpg 768w, /wp-content/uploads/sites/8/2021/11/newsletter-1-337x300.jpg 337w, /wp-content/uploads/sites/8/2021/11/newsletter-1-600x534.jpg 600w, /wp-content/uploads/sites/8/2021/11/newsletter-1-30x27.jpg 30w, /wp-content/uploads/sites/8/2021/11/newsletter-1-11x10.jpg 11w"
                            // srcSet="/wp-content/uploads/sites/8/2021/11/newsletter-1.jpg 770w, /wp-content/uploads/sites/8/2021/11/newsletter-1-300x267.jpg 300w, /wp-content/uploads/sites/8/2021/11/newsletter-1-768x683.jpg 768w, /wp-content/uploads/sites/8/2021/11/newsletter-1-337x300.jpg 337w, /wp-content/uploads/sites/8/2021/11/newsletter-1-600x534.jpg 600w, /wp-content/uploads/sites/8/2021/11/newsletter-1-30x27.jpg 30w, /wp-content/uploads/sites/8/2021/11/newsletter-1-11x10.jpg 11w"
                            sizes="(max-width: 770px) 100vw, 770px"
                          />{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b8d0414"
                    data-id="b8d0414"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-41eda22 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="41eda22"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h3 className="elementor-heading-title elementor-size-default">
                            Subscribe to Our Newsletter
                          </h3>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-e1eae86 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="e1eae86"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <p className="elementor-heading-title elementor-size-default">
                            Keep in touch with our news &amp; offers
                          </p>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-8d5e907 cmsmasters-mailchimp__inline-button-yes cmsmasters-mailchimp__button-border-default cmsmasters-mailchimp__button-position-tablet-bottom cmsmasters-mailchimp__button-align-tablet-stretch cmsmasters-mailchimp__button-position-right cmsmasters-mailchimp__button-position-mobile-bottom cmsmasters-mailchimp__terms-use-align-start cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-mailchimp"
                        data-id="8d5e907"
                        data-element_type="widget"
                        data-settings='{"action_form":"subscribe"}'
                        data-widget_type="cmsmasters-mailchimp.default"
                        data-document-id={7412}
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-widget-cmsmasters-mailchimp__wrapper">
                            <form
                              className="elementor-widget-cmsmasters-mailchimp__form"
                              method="POST"
                            >
                              <div className="elementor-widget-cmsmasters-mailchimp__fields-wrapper">
                                <div className="elementor-widget-cmsmasters-mailchimp__field-group elementor-widget-cmsmasters-mailchimp__field-group-email">
                                  <div className="elementor-widget-cmsmasters-mailchimp__button-inline-wrapper">
                                    <div className="elementor-widget-cmsmasters-mailchimp__field-outer elementor-widget-cmsmasters-mailchimp__field-gap">
                                      <input
                                        size={1}
                                        id="email-67b699d12b540"
                                        className="elementor-widget-cmsmasters-mailchimp__field"
                                        type="email"
                                        name="email"
                                        placeholder="Your email address*"
                                        required="required"
                                      />
                                    </div>
                                    <div className="elementor-widget-cmsmasters-mailchimp__field-group elementor-widget-cmsmasters-mailchimp__field-type-submit">
                                      <button
                                        className="elementor-widget-cmsmasters-mailchimp__button"
                                        name="submit"
                                        type="submit"
                                      >
                                        <span className="elementor-widget-cmsmasters-mailchimp__button-content">
                                          <span className="elementor-widget-cmsmasters-mailchimp__button-text">
                                            Subscribe
                                          </span>
                                        </span>
                                        <span className="elementor-widget-cmsmasters-mailchimp__button-preloader">
                                          <i className="fas fa-spinner" />
                                        </span>
                                      </button>
                                    </div>
                                    <div className="elementor-widget-cmsmasters-mailchimp__terms-use-position" />
                                  </div>
                                </div>
                              </div>
                              <input
                                type="hidden"
                                name="action-form"
                            
                              />
                            </form>
                            <p className="elementor-widget-cmsmasters-mailchimp__valid-message elementor-widget-cmsmasters-mailchimp__field-group">
                              Thank you for subscribing to the newsletter.
                            </p>
                            <p className="elementor-widget-cmsmasters-mailchimp__error-message elementor-widget-cmsmasters-mailchimp__field-group">
                              Oops. Something went wrong. Please try again
                              later.
                            </p>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section> */}
      <section
        className="elementor-section elementor-inner-section elementor-element elementor-element-5b6a3df elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="5b6a3df"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div className="elementor-container elementor-column-gap-no">
          <div className="container1">
            <div className="image-section">
              <img src="/imges/about/vision.jpg" alt="Money and Calculator" />
            </div>
            <div className="content-section">
              <h1>Our Vision
              </h1>
              <p>We are more than an investment firm—we are catalysts for growth. By partnering with visionary businesses and entrepreneurs, we accelerate innovation, create economic value, and shape industries of the future. Our forward-thinking approach empowers businesses to scale, adapt, and thrive in a rapidly changing world. Our vision is to redefine investment by fostering an ecosystem were businesses flourish through strategic partnerships and financial expertise</p>
              {/* <a href="#" className="btn">Contact Us</a> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default About;
